import { Skeleton } from 'antd';
import FileUpload, { FileType, RenderType } from 'components/FileUpload/FileUpload';

import {
  attachmentUploadUrl,
  selectors,
  useDeleteProjectAttachmentMutation,
  useGetProjectAttachmentsQuery
} from 'app/services/projects';

import { useSelector } from 'react-redux';
import _ from 'lodash';
import { State } from 'constants/site';
import { useHasPermission } from 'hooks/authorization/useHasPermission';
import { User } from 'constants/index';
import { useScreenBreakpoint } from 'hooks';

const readOnlyStates = [ State.EMAIL_SENT, State.CLOSED ];

const Attachments = ({ readonly }: { readonly?: boolean }) => {
  const project = useSelector(selectors.getProject);
  const [ deleteAttachment ] = useDeleteProjectAttachmentMutation();
  const canManageAttachments = useHasPermission(User.Permissions.CREATE_OR_UPDATE_PROJECTS);
  const { isMobile } = useScreenBreakpoint();

  if (!project) return null;

  const { data, isLoading, isFetching } = useGetProjectAttachmentsQuery(project.Id);

  if (!data) return null;

  if (isLoading || isFetching) return <Skeleton active />;

  const values = _.map(data, (value: any) => ({
    name: value.FileName,
    url: value.AbsoluteUri,
    uid: value.Id.toString()
  }));

  const isReadonly = !canManageAttachments || readonly || _.includes(readOnlyStates, project.State);

  return (
    <FileUpload
      uploadUrl={!isReadonly ? attachmentUploadUrl.replace(':id', project.Id.toString()) : undefined}
      actions={{ showDownload: true, showPreview: true, showDelete: !isReadonly }}
      initialValues={values}
      limit={5}
      type={FileType.ATTACHMENT}
      renderType={RenderType.GALLERY}
      listType={'picture-card'}
      deleteCallback={canManageAttachments && !readonly ? deleteAttachment : undefined}
      readonly={isReadonly}
      reopenAfterUpload={isMobile}
    />
  );
};

export default Attachments;
